import { DropTarget } from './utils';
import { getGhostStyle } from './getGhostStyle';
import { ScrollValues } from './ScrollValues';

export const updateDragTarget = (
  dragTarget: DropTarget,
  ghostContainer: HTMLElement,
  translateX: number,
  translateY: number,
  { deltaTop, deltaLeft }: ScrollValues,
  style: React.CSSProperties = {},
  onTransitionEnd: () => void = () => null
) => {
  dragTarget.translateX = translateX;
  dragTarget.translateY = translateY;
  dragTarget.currentX = dragTarget.relativeX + translateX + deltaLeft;
  dragTarget.currentY = dragTarget.relativeY + translateY + deltaTop;
  const {
    box: { width, height, x, y },
    setStateWithRefCheck,
  } = dragTarget;
  const ghostStyle = {
    ...getGhostStyle({
      width,
      height,
      x,
      y,
      translateX,
      translateY,
    }),
    ...style,
  };
  const componentStyle: React.CSSProperties = {
    opacity: 0,
    visibility: 'hidden',
  };
  setStateWithRefCheck({
    componentStyle,
    ghostStyle,
    ghostContainer,
    onTransitionEnd,
  });
};
